(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-logo-carousel').each(function () {
			const sliderEl = $(this)[0];

			const swiper = new Swiper('.js-logo-carousel', {
				direction: 'horizontal',
				slidesPerView: 'auto',
				preventInteractionOnTransition: true,
				spaceBetween: 64,
				speed: 8000,
				breakpointsBase: 'container',
				simulateTouch: false,
				loop: true,
				autoplay: {
					delay: 0,
				},

				breakpoints: {
					744: {
						spaceBetween: 80
					},

					1400: {
						spaceBetween: 130,
					},
				},

				on: {
					init: function () {
						sliderEl.classList.remove('swiper-uninitialized');
					},

					resize: function () {
						this.autoplay.start();
					},
				}
			});
		});
	});
})(jQuery, document, window);
